import React, { useState, useEffect } from 'react'
import {
  Divider, Modal, message,
} from 'antd'
import { Mutation, Query } from 'react-apollo'
import moment from 'moment'
import _ from 'lodash'
import {
  Loading, P, InputWithLabel, Button, Div, Label, H4,
} from 'konsys-ui'
import {
  Template, TextWithIcon,
} from '../reserve/utils'
import {
  ConfirmDataSpaceBetweenWrapper, BarberImg,
} from '../reserve/styled'
import Container from '../../components/container'
import { theme } from '../../styles/_variables'
import { ME, MY_APPOINTMENT } from '../../constants/graphql/query'
import { UPDATE_PROFILE, CANCEL_APPOINTMENT } from '../../constants/graphql/mutation'
import { getAccessToken } from '../../utils/local-data-service'
import history from '../../history'

const showConfirm = (func, id) => {
  Modal.confirm({
    title: 'Are you sure?',
    okText: 'Yes, cancel my booking',
    cancelText: 'Back',
    onOk() {
      func({ variables: { id } }).then((resp) => {
        if (resp.data.cancelAppointment.success) {
          message.success(resp.data.cancelAppointment.message)
        } else message.error(resp.data.cancelAppointment.message)
      })
    },
    onCancel() {
    },
  })
}

const TextWithLabel = ({ title, data, margin }) => (
  <Div margin={margin}>
    <Label margin='0 0 4px'>{title}</Label>
    <P display="block">{data}</P>
  </Div>
)

export const ProfileContainer = ({ me }) => {
  const { id, firstname, phonenumber } = me
  const [name, setName] = useState(firstname)
  const [phone, setPhone] = useState(phonenumber)
  return (
    <Div>
      <Div display='flex' flexDirection='column'>
        <InputWithLabel
          margin='8px 0'
          title={{ text: 'Name' }}
          width='100%'
          input={{
            onChange: e => setName(e.target.value),
            margin: '-8px 0 0',
            value: name,
          }}
        />
        <InputWithLabel
          margin='8px 0'
          title={{ text: 'Phone' }}
          width='100%'
          input={{
            onChange: e => setPhone(e.target.value),
            margin: '-8px 0 0',
            value: phone,
          }}
        />
        <Mutation
          mutation={UPDATE_PROFILE}
          refetchQueries={[{
            query: ME,
          }]}
        >
        {
          updateUser => (
            <Button
              inverse={true}
              fullWidth={true}
              margin='32px 0'
              text='Update Profile'
              disabled={name === '' || phone.length < 10 || (name === firstname && phone === phonenumber)}
              onClick={() => updateUser({ variables: { id, firstname: name, phonenumber: phone } }).then((resp) => {
                if (resp.data.updateUser.success) {
                  message.success(resp.data.updateUser.message)
                } else message.error(resp.data.updateUser.message)
              })}
            />
          )
        }
        </Mutation>
      </Div>
      <Divider style={{ margin: '32px 0 56px 0' }} />
      <Template>
        <H4 letterSpacing='1px' black={true}>BOOKING DETAIL</H4>
        <Query
          fetchPolicy='cache-and-network'
          query={MY_APPOINTMENT}
        >
          {
            ({ loading, data, error }) => {
              if (error) return <TextWithIcon icon='fal fa-bomb' text='Something went wrong' />
              if (loading || !data) return <Loading width='100%' center={true} />
              const bookingData = data.myWatingAppointment.appointment
              const groupedData = _.groupBy(bookingData, v => (v.start.substring(0, 7)))
              return (
                !_.isEmpty(bookingData)
                  ? _.map(groupedData, (v, index) => (
                    <div>
                      <Divider orientation='left' style={{ margin: '56px 0 32px' }}><P color={theme.color.purplishGrey}>{moment.tz(index, 'Asia/Bangkok').format('MMMM YYYY')}</P></Divider>
                      {
                        _.map(v, (w, i) => (
                          <Div>
                            <Div>
                              <TextWithLabel
                                title='Date'
                                data={`${moment.tz(w.start, 'Asia/Bangkok').format('dddd DD MMM')}, ${moment.tz(w.start, 'Asia/Bangkok').format('HH:mm')} - ${moment.tz(w.end, 'Asia/Bangkok').format('HH:mm')}`}
                                id='booking-detail'
                              />
                              <ConfirmDataSpaceBetweenWrapper>
                                <Div margin='0 120px 0 0'>
                                  <Label>Selected Services</Label>
                                  {
                                    _.map(w.services, (x, ind) => (
                                      <P
                                        margin={ind !== 0 && '4px 0 0'}
                                        key={ind}
                                        display="block"
                                      >{x.serviceName}({x.time} mins) - {x.price} Baht</P>
                                    ))
                                  }
                                </Div>
                                <Div>
                                  <Label margin='0 0 4px'>Selected Barber</Label>
                                  <Div display='flex'>
                                    <BarberImg img={w.barber.barberImage} />
                                    <P margin='0 0 0 8px'>{w.barber.barberName}</P>
                                  </Div>
                                </Div>
                              </ConfirmDataSpaceBetweenWrapper>
                              <TextWithLabel title='Location' data={w.shop.shopname} />
                              <Mutation
                                mutation={CANCEL_APPOINTMENT}
                                refetchQueries={[{
                                  query: MY_APPOINTMENT,
                                }]}
                              >
                              {
                                cancelAppointment => (
                                  <Button
                                    text='Cancel this booking'
                                    margin='32px 0 0'
                                    fullWidth={true}
                                    onClick={() => showConfirm(cancelAppointment, w.id)}
                                  />
                                )
                              }
                              </Mutation>
                            </Div>
                            {
                              i !== (v.length - 1) && <Divider style={{ margin: '40px 0' }} />
                            }
                          </Div>
                        ))
                      }
                    </div>
                  ))
                  : <Div display='flex' justifyContent='center' alignItems='center' margin='24px 0 0'><P color={theme.color.purplishGrey}>{data.myWatingAppointment.message}</P></Div>
              )
            }
          }
        </Query>
      </Template>
    </Div>
  )
}

export const ProfilePage = () => {
  useEffect(() => {
    if (!getAccessToken()) {
      history.push('/')
    }
  }, [])
  return (
    <Query
      query={ME}
    >
    {
      ({ loading, data, error }) => {
        if (error) return <TextWithIcon icon='fal fa-bomb' text='Something went wrong' />
        if (loading || !data) return <Loading width='100%' center={true} />
        return (
          <Container profile email={data.me.email}>
            <ProfileContainer me={data.me}/>
          </Container>
        )
      }
    }
    </Query>
  )
}

export default ProfilePage



// WEBPACK FOOTER //
// ./src/pages/profile/index.jsx